const TIER_ORDER = ['free', 'pro', 'team', 'agency'] as const;

type KnownTier = typeof TIER_ORDER[number];

const normalizeTier = (tier?: string | null): KnownTier | undefined => {
  if (!tier) return undefined;
  return TIER_ORDER.includes(tier as KnownTier) ? (tier as KnownTier) : undefined;
};

export const getTierRank = (tier?: string | null) => {
  const normalized = normalizeTier(tier);
  if (!normalized) {
    return 0;
  }
  return TIER_ORDER.indexOf(normalized);
};

export const canUpgradeTier = (tier?: string | null) => {
  const rank = getTierRank(tier);
  return rank < TIER_ORDER.length - 1;
};

export const filterUpgradeablePlans = <T extends { tier: string }>(
  plans: T[],
  currentTier?: string | null,
) => {
  const currentRank = getTierRank(currentTier);
  return plans.filter((plan) => getTierRank(plan.tier) > currentRank);
};
